import { useContext } from "react";

import { LayoutContext } from "layout/context/LayoutContext";

const usePermissions = (permission) => {
  const {
    me: { permissions: basePermissions },
  } = useContext(LayoutContext);

  if (Array.isArray(permission))
    return permission?.map((per) => basePermissions?.includes(per));

  return basePermissions?.includes(permission);
};

export default usePermissions;
